import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {environment} from '../../environments/environment';
import {PartSearchResult} from '../products/part-search-result';
import {GoogleService} from './google-service';
import {map} from 'rxjs/operators';

@Service()
export class PartsService {
  private readonly http = inject(HttpClient);
  private readonly googleService = inject(GoogleService);


  private urlBase = environment.serviceUrl;

  public searchParts(searchTerm: string, warranty: boolean, entityId: string, entityRevision: number, orderYear: number): Observable<PartSearchResult> {
    const url = this.urlBase + 'parts/' + searchTerm + '/' + warranty;
    let params = new HttpParams();
    if (entityId && entityId.length > 0) {
      params = params.set('entityId', entityId).set('revision', entityRevision);
    }
    if (orderYear) {
      params = params.set('orderYear', orderYear);
    }
    return this.http.get<PartSearchResult>(url, {headers: this.getRequestHeaders(), params});
  }

  private getRequestHeaders(): HttpHeaders {
    return new HttpHeaders().set(GoogleService.TokenHeader, this.googleService.getAccessToken());
  }

  isDrawingAvailable(partNumber: string): Observable<string> {
    const url = this.urlBase + 'parts/drawingFile/isAvailable/' + encodeURIComponent(partNumber);
    return this.http.get(url, {headers: this.getRequestHeaders(), responseType: 'text'});
  }

  getDrawingFile(partNumber: string): Observable<Blob> {
    const url = this.urlBase + 'parts/drawingFile/download/' + encodeURIComponent(partNumber);
    return this.http.get(url, {
      headers: this.getRequestHeaders(),
      observe: 'response',
      responseType: 'blob'
    }).pipe(map((response: any) => {
      return new Blob([response.body], {type: response.headers.get('Content-Type')});
    }));
  }

}
